/*!
 * Copyright © 2019-2021. Verizon Connect Ireland Limited. All rights reserved.
 */

import { EAssetDateRangeSelectionMode, IPolylineHoverParams } from '../../../core/models';
import { EPanelDrawerState, IReplayBalloonVideo, IReplayJourney } from '../../models';

export interface IReplayState {
  journey: IReplayJourney;
  isLoadingJourney: boolean;
  isReplayOptionsOpen: boolean;
  selectedSegmentId: number;
  isSelectedSegmentSticky: boolean;
  hoveredSegmentId: number;
  shouldAnimatePlots: boolean;
  canClickViewAll: boolean;
  canFitToMap: boolean;
  dateSelectionMode: EAssetDateRangeSelectionMode;
  drawerState: EPanelDrawerState;
  multidaySelectedDay?: number;
  hoveredPolyline?: IPolylineHoverParams;
  balloonVideo?: IReplayBalloonVideo;
  isVideoRequested: boolean;
  verifiedRecentActivityDate: Date | null;
}

export const initialReplayState: IReplayState = {
  journey: null,
  isLoadingJourney: false,
  isReplayOptionsOpen: false,
  selectedSegmentId: null,
  isSelectedSegmentSticky: false,
  hoveredSegmentId: null,
  shouldAnimatePlots: false,
  canClickViewAll: false,
  multidaySelectedDay: null,
  hoveredPolyline: null,
  canFitToMap: false,
  drawerState: null,
  balloonVideo: null,
  dateSelectionMode: EAssetDateRangeSelectionMode.Previous7Days,
  isVideoRequested: false,
  verifiedRecentActivityDate: null
};
